import { useCallback, useContext, useEffect } from "react";
import useFetchAndTrace from "../../fetchWithTrace";
import { Board, setProjectName } from "../../../../reducers/uploadedBoard";
import settings from "../../../../constants/settings";
import { useBoardFromContext } from "./board";
import { useDebouncedCallback } from "use-debounce";
import { useStringInput } from "../../inputs";
import { DEMO_BOARD_SLUG } from "../../../../constants/boards";
import { useAppDispatch } from "../../store";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "./state-machine/reviewBoardFlowLoader";

export const useProjectName = () => {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const boardStuff = useBoardFromContext();
  const board = boardStuff.board as Board;
  const { value: projectNameCache, bind: bindProjectNameCache } =
    useStringInput(board.project_name);
  const fetchAndTrace = useFetchAndTrace();
  const dispatch = useAppDispatch();

  const getHandler = useCallback((response: Response) => {
    if (!response.ok) {
      throw Error("Failed to save project name");
    }
  }, []);

  const debouncedUpdateProjectName = useDebouncedCallback(
    (newProjectName: string) => {
      if (board.id != DEMO_BOARD_SLUG) {
        void fetchAndTrace(
          `${settings.api_url}/boards/${board.id}/project-name`,
          getHandler,
          null,
          {
            body: JSON.stringify({
              project_name: newProjectName,
            }),
            method: "PUT",
          },
        );
      }
    },
    500,
  );

  useEffect(() => {
    if (
      projectNameCache !== board.project_name &&
      projectNameCache &&
      boardId
    ) {
      dispatch(setProjectName({ boardId, projectName: projectNameCache }));
      void debouncedUpdateProjectName(projectNameCache);
    }
  }, [
    board.project_name,
    debouncedUpdateProjectName,
    dispatch,
    projectNameCache,
    boardId,
  ]);

  return {
    bindProjectNameCache,
  };
};
